export default {
  id: 'ContactDockInfo',
  code: 'CN',
  text: {
    'Info': '联系人档案',
    'Edit': '编辑',

    'Basic Info': '基本信息',
    "Other Info": "其他信息",    
    'Name': '姓名',
    'Gender': '性别',
    'Date of Birth': '生日',
    'Phone No.': '联系电话',
    'Email': '联系邮箱',
    'Guardian Name': '家长姓名',
    'Guardian Email': '家长邮箱',
    'Guardian Phone No.': '家长电话',
    'Remarks': '备注',
    'Tag': '标签',
    'Created At': '创建时间',

    'Notes': '备忘',
    'Male': '男',
    'Female': '女',
    'Other': '其他',
    'N/A': '未提供'

  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/locale.js